import {
    CATEGORY_CASINO,
    CATEGORY_SLOTS,
    CATEGORY_SUBTYPE_LIVE,
    CATEGORY_BINGO,
    CATEGORY_SUBTYPE_COLLECTOR,
} from '../constants'

export const useGameType = () => {
    const isLiveCasino = (gameType: string | undefined, gameSubType: string | undefined): boolean => gameType?.toLowerCase() === CATEGORY_CASINO.toLowerCase() && gameSubType?.toLowerCase() === CATEGORY_SUBTYPE_LIVE.toLowerCase()
    const isCasino = (gameType: string | undefined): boolean => gameType?.toLowerCase() === CATEGORY_CASINO.toLowerCase()
    const isSlot = (gameType: string | undefined): boolean => gameType?.toLowerCase() === CATEGORY_SLOTS.toLowerCase()
    const isBingo = (gameType: string | undefined): boolean => gameType?.toLowerCase() === CATEGORY_BINGO.toLowerCase()
    const isCollector = (gameType: string | undefined): boolean => gameType?.toLowerCase() === CATEGORY_SUBTYPE_COLLECTOR.toLowerCase()

    const isBingoSlug = (slug: string | undefined): boolean => slug && ['bingo', 'bingo-90', 'midnight-bingo'].includes(slug) ? true : false

    return {
        isLiveCasino,
        isCasino,
        isSlot,
        isBingo,
        isCollector,
        isBingoSlug,
    }
}
